import { PromoCodeCreatedBy, PromoCodeTag } from '../../../../../../services/exports/Constants';

export default {
  title: 'Codes promo',
  tabs: {
    active: 'Actif',
    expired: 'Expiré',
    email_sign_up: 'Inscription par e-mail avec promo',
  },
  show_master_promo_code: 'Afficher le code promo maître aux clients',
  send_rejected_order_apologies_promo_code: "Envoyer un code promo aux clients lors d'un refus manuel de commande",
  filters: {
    tag: {
      placeholder: 'Tag',
      options: {
        [PromoCodeTag.Master]: 'Maître',
        [PromoCodeTag.Campaign]: 'Campagne',
        [PromoCodeTag.OneTime]: 'Usage unique',
      },
    },
    code: {
      placeholder: 'Code',
    },
    campaign: {
      placeholder: 'Campagne',
    },
    created_by: {
      placeholder: 'Créé par',
      options: {
        [PromoCodeCreatedBy.User]: 'Utilisateur',
        [PromoCodeCreatedBy.System]: 'Système',
      },
    },
  },
  fields: {
    code: 'Code',
    tag: 'Tag',
    type: 'Type',
    discount_type: 'Type de remise',
    discount: 'Remise',
    usage_threshold: "Seuil d'utilisation",
    quantity: 'Quantité',
    expires_at: 'Expire',
    level: 'Niveau',
    max_discount: 'Remise maximale',
    created_by: 'Créé par',
    image: 'Image',
  },
  tags: {
    [PromoCodeTag.Master]: 'Maître',
    [PromoCodeTag.Campaign]: 'Campagne',
    [PromoCodeTag.OneTime]: 'Usage unique',
  },
  types: {
    single_use: 'Usage unique',
    multi_use: 'Multi-usage',
    unknown: 'Inconnu',
  },
  discount_types: {
    fixed_amount: 'Montant fixe',
    percentage: 'Pourcentage',
    unknown: 'Inconnu',
  },
  created_by: {
    [PromoCodeCreatedBy.User]: 'Utilisateur',
    [PromoCodeCreatedBy.System]: 'Système',
  },
  labels: {
    discount: 'Remise',
    usage_threshold: "Seuil d'utilisation",
    company: 'Société',
    restaurant: 'Restaurant',
    restaurant_group: 'Marque',
  },
  buttons: {
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    restore: 'Restaurer',
    add_promo_code: 'Ajouter un code promo',
    images: "Gérer l'image",
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_save_settings: "Échec de l'enregistrement des modifications",
    failed_to_delete_promo_code: 'Échec de la suppression du code promo',
    failed_to_restore_promo_code: 'Échec de la restauration du code promo',
    promo_code_got_deleted: 'Code promo supprimé',
    promo_code_got_restored: 'Code promo restauré',
  },
  delete_confirmation: {
    title: 'Supprimer le code promo ?',
    buttons: {
      yes: 'Oui',
      no: 'Non',
    },
  },
  restore_confirmation: {
    title: 'Restaurer le code promo ?',
    buttons: {
      yes: 'Oui',
      no: 'Non',
    },
  },
};
